/** @see $bog_builderui_tokens */
namespace $ {
	$mol_style_define( $bog_builderui_button, {
		font: {
			family: $bog_builderui_tokens.font_body,
			weight: 500,
		},
		color: $bog_builderui_tokens.back,
		background: {
			color: $bog_builderui_tokens.control,
		},
		border: {
			radius: $bog_builderui_tokens.radius,
			width: 0,
		},
		padding: {
			top: '0.5rem',
			bottom: '0.5rem',
			left: '1rem',
			right: '1rem',
		},
	} )
}
